import React, {useRef} from 'react'
import CushHead from '../../images/cushhead.png'
import {Link} from "react-router";


const Header = props => {
  const { ref } = props;
  return <div className="flex items-center gap-6 sticky top-0 justify-center bg-[#2B4B9F] z-20">
    <Link to ='/' className="flex items-center justify-center gap-2 w-fit p-4 h-28" ref={ref}>
      <img src={CushHead} className="h-full object-cover" />
      <h1 className="text-4xl md:text-5xl font-[Axiforma_Heavy] text-[#4F98BD] tracking-wide mt-1">CUSHVLOG</h1>
    </Link>
  </div>
}

export const ScreenLayout = ({ children, ...props }) => {
  const { width } = props
  const headerRef = useRef({});
  const bodyRef = useRef({});
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    if (!headerRef.current) { return }
    if (!bodyRef.current) { return }
    if (width === 'full') {
      setIsLoaded(true)
      return
    }

    const header = headerRef.current

    if (!header) { return; }

    const w = header.clientWidth;
    bodyRef.current.style.width = header.clientWidth;
    setIsLoaded(true)
  }, [])

  return <div className={`flex flex-col gap-6 p-6 ${!isLoaded && 'invisible'}`}>
    <Header ref={headerRef} />
    <div className={`flex flex-col items-center justify-center overflow-x-hidden`}>
      <div className="w-full" ref={bodyRef}>
        {children}
      </div>
    </div>
  </div>
}